export const lightGroupsConfig = {
  subsolo01: [
    { id: "grupo38", modulo: "5", idx: "6", descricao: "Vigia SS1", lightType: "normal",
      instances: [
        // 1 parte
        { x: 21.5, y: 24, width: 2.5, height: 5, circleNumber: 38 },
        { x: 40, y: 24, width: 2.5, height: 5, circleNumber: 38 },
        { x: 57, y: 24, width: 2.5, height: 5, circleNumber: 38 },
        { x: 73, y: 24, width: 2.5, height: 5, circleNumber: 38 },

        { x: 33, y: 33, width: 2.5, height: 5, circleNumber: 38 },
        { x: 53, y: 33, width: 2.5, height: 5, circleNumber: 38 },

        { x: 23, y: 50, width: 2.5, height: 5, circleNumber: 38 },
        { x: 62, y: 50, width: 2.5, height: 5, circleNumber: 38 },

        { x: 18, y: 77, width: 2.5, height: 5, circleNumber: 38 },
        { x: 41, y: 77, width: 2.5, height: 5, circleNumber: 38 },
        { x: 63, y: 77, width: 2.5, height: 5, circleNumber: 38 },

        { x: 14, y: 87, width: 2.5, height: 5, circleNumber: 38 },
        { x: 39, y: 87, width: 2.5, height: 5, circleNumber: 38 },
        { x: 51, y: 87, width: 2.5, height: 5, circleNumber: 38 },
        { x: 84, y: 86, width: 2.5, height: 5, circleNumber: 38 },

      ]},
    ],

  subsolo02: [
    {
      id: "grupo39", modulo: "5", idx: "7", descricao: "Vigia SS2", lightType: "normal",
      instances: [
        { x: 21.5, y: 24, width: 2.5, height: 5, circleNumber: 39 },
        { x: 40, y: 24, width: 2.5, height: 5, circleNumber: 39 },
        { x: 57, y: 24, width: 2.5, height: 5, circleNumber: 39 },
        { x: 73, y: 24, width: 2.5, height: 5, circleNumber: 39 },

        { x: 33, y: 33, width: 2.5, height: 5, circleNumber: 39 },
        { x: 53, y: 33, width: 2.5, height: 5, circleNumber: 39 },

        { x: 23, y: 50, width: 2.5, height: 5, circleNumber: 39 },
        { x: 62, y: 50, width: 2.5, height: 5, circleNumber: 39 },

        { x: 18, y: 77, width: 2.5, height: 5, circleNumber: 39 },
        { x: 41, y: 77, width: 2.5, height: 5, circleNumber: 39 },
        { x: 63, y: 77, width: 2.5, height: 5, circleNumber: 39 },

        { x: 14, y: 87, width: 2.5, height: 5, circleNumber: 39 },
        { x: 39, y: 87, width: 2.5, height: 5, circleNumber: 39 },
        { x: 51, y: 87, width: 2.5, height: 5, circleNumber: 39 },
        { x: 84, y: 86, width: 2.5, height: 5, circleNumber: 39 },
      ]},
  ],

  subsolo03: [
    {
      id: "grupo40", modulo: "5", idx: "8", descricao: "Circuito 50", lightType: "normal",
      instances: [
        { x: 500, y: 500, width: 0, height: 0, circleNumber: 50 },
      ],
    },
  ],
};